import type {SVGProps} from 'react'
const ChevronLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 1000 1000"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M307.32,500.01l350,349.99,35.35-35.35-314.64-314.64,314.66-314.65-35.36-35.36-350.02,350.01h.01Z" />
  </svg>
)
export {ChevronLeftIcon}
